import { FIELD_TYPES } from "@hyro-components/fields/utils";

export const COLUMNS = {
  name: {
    id: "name",
    label: "Name",
  },
  accountId: {
    id: "accountId",
    label: "Account Id",
  },
  creator: {
    id: "creator",
    label: "Creator",
  },
  createdAt: {
    id: "createdAt",
    label: "Created At",
  },
  twilioId: {
    id: "twilioId",
    label: "Twilio Id",
  },
  timezone: {
    id: "timezone",
    label: "Timezone",
  }
};

export const FILTERS = Object.values(COLUMNS).map((column) => ({
  key: column.id,
  label: column.label,
  type: FIELD_TYPES.TEXT
}));
